// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__35RBl","footer":"ChangeClinic_footer__1Qp_R"};